import mobile from './ui.mobile.js';
import desktop from './ui.desktop.js';

const modules = {
  mobile,
  desktop,
};

export default modules;
